import { render, staticRenderFns } from "./YourStory.vue?vue&type=template&id=4ddfd501"
import script from "./YourStory.vue?vue&type=script&lang=ts"
export * from "./YourStory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports